/** Search input rules (BR-8). The API returns nothing below 2 characters, so we don't ask. */
export const MIN_QUERY_LENGTH = 2

/** NFC + trim + collapsed spaces — what we send and log. Case is left to the server. */
export function cleanQuery(q: string): string {
  return q.normalize('NFC').trim().replace(/\s+/g, ' ')
}

export function isSearchable(q: string): boolean {
  return [...cleanQuery(q)].length >= MIN_QUERY_LENGTH
}
